module.exports = __webpack_public_path__ + "images/emoji/rage2.b9b041ae30d95826dbf8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rage2.png
// module id = WpWN
// module chunks = 14